import type { LocaleResources } from '../types';

/**
 * Page related UI string resources
 * Login, license selection, and other page-level strings
 */
export const pageStr: LocaleResources['pageStr'] = {
  login: {
    title: 'Login',
    botSelect: 'Please select a Bot.',
    botNumber: 'Bot #{num}',
    idRequired: 'Please enter your ID.',
    pwRequired: 'Please enter your password.',
    invalidCredentials: 'Invalid ID or password.',
  },
  licenseSelect: {
    title: 'Select License',
  },
  bottomPanel: {
    tradeHistory: 'Trade History',
    log: 'Log',
  },
  monitor: {
    symbol: 'Symbol',
    time: 'Time',
    status: 'Status',
    action: 'Action',
  },
  progress: {
    completed: '{completed} / {total} completed',
  },
};
